/**
 * transport/backoff.ts —— 指数退避＋抖动（CONTRACT §5：上限默认建议 30s）。
 * 纪律：重连节奏只由本件决定（可注入 rand 保确定性）；不自造第二套退避。
 */

export interface BackoffOptions {
  /** 基础步长（ms） */
  baseMs: number;
  /** 退避上限（ms；CONTRACT §5 默认建议 30s） */
  capMs: number;
  /** 抖动比例（±jitterRatio） */
  jitterRatio: number;
}

export const DEFAULT_BACKOFF: BackoffOptions = {
  baseMs: 300,
  capMs: 30_000,
  jitterRatio: 0.2,
};

/**
 * 第 attempt 次（从 0 计）重连的延迟：min(cap, base·2^attempt) ± 抖动。
 * rand 可注入（测试确定性）；缺省 Math.random。
 */
export function backoffDelayMs(
  attempt: number,
  opts: BackoffOptions = DEFAULT_BACKOFF,
  rand: () => number = Math.random,
): number {
  const raw = opts.baseMs * Math.pow(2, Math.max(0, attempt));
  const capped = Math.min(opts.capMs, raw);
  const jitter = capped * opts.jitterRatio * (2 * rand() - 1);
  return Math.max(0, Math.round(capped + jitter));
}
